import * as api from '../api/api';
import pageUtil from '../utils/page';
import {
    scrollDownChatListAction,
    toggleIM,
    updateCustomerServiceAccount,
    updateShowChat,
    showDialog,
    setImgUrl,
} from './actionCreators';
import actions from './index';

/**
 * 初始化 IM
 * @param pid
 * @param userId 用户 Id
 * @param userName 用户昵称
 * @param icon 用户头像 URL
 * @return {function(*, *): *}
 */
export function initializeIM({ icon, userId, userName, pid }) {
    return async (dispatch, getState) => {
        let userData;
        try {
            const response = await api.postRequest(api.REGISTER_IM, {
                icon,
                userId,
                userName,
                pid,
            });
            userData = response.data;
        } catch (e) {
            console.error(e);
            return;
        }

        try {
            const { data } = await api.getRequest(api.GET_CUSTOMER_SERVER);
            const { accid: accountId } = data;
            dispatch(updateCustomerServiceAccount(accountId));
        } catch (e) {
            console.error(e);
            return;
        }

        return dispatch(actions.connect({ uid: userData.accid, sdktoken: userData.token }));
    };
}

export function getCustomerServer() {
    return async (dispatch, getState) => {
        let customerServerId = '';
        try {
            const response = await api.getRequest(api.GET_CUSTOMER_SERVER);
            customerServerId = response.data.accid;
        } catch (e) {
            console.error(e);
            return;
        }
        // actions.insertLocalSession('customerServerId')
        return dispatch(createSession(customerServerId));
    };
}

/**
 * 创建会话
 * @param to - 接受人 Id
 * @return {function(*, *): *}
 */
export function createSession(to) {
    return (dispatch, getState) => {
        dispatch(actions.insertLocalSession(to));
        dispatch(actions.setCurrSession(`p2p-${to}`));
        dispatch(toggleIM(true));
        dispatch(updateShowChat(true));
        // dispatch(actions.addFriend(to));
    };
}

export function scrollChatListDown() {
    return (dispatch, getState) => {
        dispatch(scrollDownChatListAction());
        pageUtil.scrollChatListDown();
    };
}

export function showImageDialog(isShown) {
    return (dispatch, getState) => {
        dispatch(showDialog(isShown));
    };
}

export function setImg(url) {
    return (dispatch, getState) => {
        dispatch(setImgUrl(url));
    };
}

export function externalInit(notificationCallback, switchSessionCallback, userInfo) {
    return dispatch => {
        dispatch(initializeIM(userInfo));
        dispatch(actions.setNotificationCallback(notificationCallback));
        dispatch(actions.setSwitchSessionCallback(switchSessionCallback));
    };
}
